var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('single-image',_vm._b({attrs:{"accept":".png,.jpg","inputId":_vm.inputId,"schema":_vm.schema,"mediaURL":_vm.mediaURL,"queryString":_vm.queryString},on:{"error":_vm.handleError}},'single-image',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }